import { useCallback, useEffect, useState } from "react";
import { raffleService } from "../../../services/api";

/**
 * Promociones / rifas públicas (las administra marketing desde el admin).
 * Con el módulo de rifas apagado el backend responde `feature_disabled: true`, pero sigue
 * devolviendo las promociones informativas (PROMO_INFO): la lista manda, no el flag.
 * @param {{ status?: string, kind?: string }} [params]
 */
export default function usePromotions({ status, kind } = {}) {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [featureDisabled, setFeatureDisabled] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    raffleService.list({ status, kind }).then((res) => {
      if (cancelled) return;
      setPromotions(res.data);
      setFeatureDisabled(res.featureDisabled);
      setFailed(!res.ok);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [status, kind, reloadKey]);

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  return { promotions, loading, failed, featureDisabled, reload };
}
